import { defineMessages } from 'react-intl'

/* Errors taken by reverse engineering Stripe Elements sdk */

// "errors.code.incorrect_cvc": "Your card's security code is incorrect.",
// "errors.code.incorrect_number": "Your card number is incorrect.",
// "errors.code.incorrect_zip": "Your card number and postal code do not match.",
// "errors.code.invalid_cvc": "Your card's security code is invalid.",
// "errors.code.processing_error": "An error occurred while processing your card. Try again in a little bit.",
// "errors.code.process_error_intransient": "An error occurred while processing your card.",
// "errors.code.unexpected": "An unexpected error occurred.",
// "errors.declines.call_issuer": "Your card was declined. You can call your bank for details.",
// "errors.declines.card_velocity_exceeded": "Your card was declined for making repeated attempts too frequently.",
// "errors.declines.currency_not_supported": "Your card is not supported for this currency.",
// "errors.declines.fake_merchant_test_card": "This verification trigger card was declined. This card must be used for a Custom account created in testmode.",
// "errors.declines.generic_decline": "Your card was declined.",
// "errors.declines.incorrect_pin": "Incorrect PIN.",
// "errors.declines.insufficient_funds": "Your card has insufficient funds.",
// "errors.declines.invalid_account": "Invalid account.",
// "errors.declines.invalid_amount": "Invalid amount.",
// "errors.declines.live_mode_test_card": "Your card was declined. Your request was in live mode, but used a known test card.",
// "errors.declines.not_permitted": "Cardmember not enrolled / not permitted",
// "errors.declines.pin_try_exceeded": "Allowable number of PIN tries exceeded.",
// "errors.declines.test_mode_live_card": "Your card was declined. Your request was in test mode, but used a non test card. For a list of valid test cards, visit: https://stripe.com/docs/testing.",
// "errors.declines.transaction_not_allowed": "Your card does not support this type of purchase.",

export const typeMessages = defineMessages({
    api_connection_error: {
        defaultMessage: 'No se pudo conectar con el proveedor de pago',
    },
    invalid_request_error: {
        defaultMessage: 'Este método de pago no se puede volver a utilizar.',
    },
})

// NOTE: Some of these errors may come from server as well as from client side validation
export const codeMessages = defineMessages({
    expired_card: {
        defaultMessage: 'La tarjeta ha caducado.',
    },
    card_declined: {
        defaultMessage: 'La tarjeta ha sido rechazada.',
    },
    invalid_number: {
        defaultMessage: 'No es un número de tarjeta válido.',
    },
    invalid_expiry_year: {
        defaultMessage: 'El año es ínvalido.',
    },
    invalid_expiry_year_past: {
        defaultMessage: 'La fecha ya ha pasado.',
    },
    invalid_expiry_month: {
        defaultMessage: 'El mes es ínvalido.',
    },
    invalid_expiry_month_past: {
        defaultMessage: 'El mes ya ha pasado.',
    },
    incomplete_number: {
        defaultMessage: 'El número de tarjeta está incompleto.',
    },
    incomplete_expiry: {
        defaultMessage: 'Fecha de validez incompleta.',
    },
    incomplete_cvc: {
        defaultMessage: 'El CVC está incompleto.',
    },
    setup_intent_authentication_failure: {
        defaultMessage: 'Para poder añadir tu tarjeta necesitas completar el proceso de validación. Vuelve a intentarlo de nuevo.',
    },
    payment_intent_authentication_failure: {
        defaultMessage: 'Para poder usar tu tarjeta necesitas completar el proceso de validación. Vuelve a intentarlo de nuevo.',
    },
})

export const declinesMessages = defineMessages({
    card_not_supported: {
        defaultMessage: 'La tarjeta no está soportada',
    },
})
